export function c3LongRound(n: number): number {
    if(n <= 1) {
        return n;
    }
    if(n <= 10) {
        return Math.ceil(n / 10) * 10;
    }
    if(n <= 100) {
        return Math.ceil(n / 10) * 10;
    }
    if(n <= 1000) {
        return Math.ceil(n / 10) * 10;
    }
    if(n <= 10000) {
        return Math.ceil(n / 1000) * 1000;
    }
    if(n <= 100000) {
        return Math.ceil(n / 1000) * 1000;
    }
    if(n <= 1000000) {
        return Math.ceil(n / 100000) * 100000;
    }
    if(n <= 10000000) {
        return Math.ceil(n / 1000000) * 1000000;
    }
    if(n <= 100000000) {
        return Math.ceil(n / 10000000) * 10000000;
    }
    if(n <= 1000000000) {
        return Math.ceil(n / 10000000) * 10000000;
    }
    if(n <= 10000000000) {
        return Math.ceil(n / 10000000) * 10000000;
    }

    return n;
}

export function c3LongRoundMin(n: number): number {
    if(n <= 1) {
        return n;
    }
    if(n <= 10) {
        return (Math.ceil(n / 10) * 10) - 10;
    }
    if(n <= 100) {
        return (Math.ceil(n / 10) * 10) - 10;
    }
    if(n <= 1000) {
        return (Math.ceil(n / 10) * 10) - 10;
    }
    if(n <= 10000) {
        return (Math.ceil(n / 1000) * 1000) - 1000;
    }
    if(n <= 100000) {
        return (Math.ceil(n / 1000) * 1000) - 1000;
    }
    if(n <= 1000000) {
        return (Math.ceil(n / 100000) * 100000) - 100000;
    }
    if(n <= 10000000) {
        return (Math.ceil(n / 1000000) * 1000000) - 1000000;
    }
    if(n <= 100000000) {
        return (Math.ceil(n / 10000000) * 10000000) - 10000000;
    }
    if(n <= 1000000000) {
        return (Math.ceil(n / 10000000) * 10000000) - 10000000;
    }
    if(n <= 10000000000) {
        return (Math.ceil(n / 10000000) * 10000000) - 10000000;
    }

    return n;
}

export function c3MinMax(n: number[]) {
    return [Math.min(...n), Math.max(...n)];
}

export function c3DataMaxValue(n: number[], type: string):number {
    if (type === 'percentage') {
        return 1;
    }
    if (type === 'percentageLimit') {
        return Math.max(...n);
    }
    if (type === 'bar') {
        let numberData = n.map((row: any) => {
            return row.filter((item: any) => typeof item !== 'string');
        });
        return c3LongRound(Math.max(...numberData.map((item: any) => Math.max(...item))));
    }
    let filteredArray = n.map((item: any) => item.filter((childItem: any) => typeof childItem !== 'string'));
    return c3LongRound(Math.max(...filteredArray.reduce((a: any, b: any) => a.map((x: any, i: any) => x + b[i]))));
}

export function getY2(data: any, format: any, options: any) {
    let axes = {};
    let types = {};
    let y2;

    if (data.length) {
        axes = data.reduce((acc: any, curr: any) => {
            acc[curr[0]] = 'y2';
            return acc;
        }, {});

        types = data.reduce((acc: any, curr: any) => {
            acc[curr[0]] = 'line';
            return acc;
        }, {});

        let filteredData = data.reduce((acc: any, curr: any) => {
            return [...acc, ...curr.filter((item:any) => typeof item === 'number')]
        }, []);

        let y2MinMax = c3MinMax(filteredData);
        let min = filteredData.length === 1 ? 0 : c3LongRoundMin(y2MinMax[0]);
        if(options && options.fromZero) { min = 0;}
        let max = c3LongRound(y2MinMax[1]);

        y2 = {
            show: true,
            padding: { top: 0, bottom: 0},
            min,
            max,
            tick: {
                format: format,
                count: 5
            }
        }

    }

    return { axes, types, y2 }
}



// WEBPACK FOOTER //
// ./src/core/c3-extensions.ts